import { render, staticRenderFns } from "./ReportsListingEmptyStateFavorite.vue?vue&type=template&id=f8f52cd4&"
import script from "./ReportsListingEmptyStateFavorite.vue?vue&type=script&lang=js&"
export * from "./ReportsListingEmptyStateFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports